import { css } from '@emotion/core'
import theme from 'Theme'

const { typography } = theme

export const embedVariantSkin = () => css`
  position: fixed;
  overflow-y: scroll;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;

  .product-modal {
    &__wrapper {
      width: 100%;
      height: 100%;
    }

    &__header {
      position: relative;
      background-color: black;
      color: white;
      font-size: ${typography.sizes.small};
      &__title {
        font-weight: bold;
        text-align: center;
        padding: 10px 40px 10px 10px;
      }
    }

    &__content {
      background-color: white;
      padding: 10px;
    }
  }

  .close-icon {
    position: absolute;
    top: calc(50% - 13px);
    right: 10px;
    z-index: 4;
    width: 26px;
    height: 26px;
    fill: white;

    &:hover {
      cursor: pointer;
    }
  }
`

export default embedVariantSkin
